<template>
  <b-card class="select-check-in-card">
    <div class="text-center">
      <span class="d-block text-uppercase text-semibold-black text-size-20">
        Choose Your
      </span>
      <span class="d-block text-uppercase text-semibold-primary text-size-24">
        Organization to Check-in
      </span>
      <span class="text-size-12">
        You can multiple check-in from the following available request
      </span>
      <div
        class="d-flex flex-column align-items-center mt-1 available-check-in-box-container"
      >
        <div
          v-for="(checkIn, index) in availableSelfCheckInList"
          :key="index"
          class="available-check-in-box"
          :class="{ 'active-card': checkIn.isSelect }"
          @click.prevent="checkIn.isSelect = !checkIn.isSelect"
        >
          <div class="row">
            <div class="col-1 custom-margin-top-6">
              <atom-checkbox v-model="checkIn.isSelect" />
            </div>
            <div class="col-11 text-left">
              <div class="d-flex">
                <div class="organization-name-container">
                  <span
                    :class="[
                      checkIn.isSelect
                        ? 'text-semibold-primary'
                        : 'text-semibold-black',
                    ]"
                  >
                    {{ checkIn.customerName }}
                  </span>
                </div>
                <span>&nbsp;({{ checkIn.siteAccessId }})</span>
              </div>
              <div>
                <span>
                  {{
                    customFormatDateTime(
                      checkIn.requestStartDate,
                      "yyyy-MM-dd'T'HH:mm:ss",
                      "dd LLL yyyy HH:mm"
                    )
                  }}
                  -
                  {{
                    customFormatDateTime(
                      checkIn.requestEndDate,
                      "yyyy-MM-dd'T'HH:mm:ss",
                      "dd LLL yyyy HH:mm"
                    )
                  }}
                </span>
              </div>
              <div class="request-description-box custom-margin-top-6">
                <span class="text-size-12 custom-sub-max-width">{{
                  checkIn.description
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3 d-flex justify-content-center">
      <atom-button
        buttonId="check-in-btn"
        class="check-in-width"
        @click="clickCheckIn"
      >
        Check-in
      </atom-button>
    </div>
  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"
import mixinsDatetime from "@/mixins/mixinsDatetime"
export default {
  name: "MoleculeSelectSelfCheckInListCard",
  components: {
    BCard,
    AtomButton,
    AtomCheckbox,
  },
  mixins: [mixinsDatetime],
  props: {
    availableSelfCheckInList: {
      type: Array,
      required: true,
    },
  },
  emits: ["onConfirmSelectCheckIn"],
  methods: {
    clickCheckIn() {
      this.$emit("onConfirmSelectCheckIn", this.availableSelfCheckInList)
    },
  },
}
</script>

<style lang="scss" scoped>
.select-check-in-card {
  padding: 12px;
  min-height: 550px;
  width: 600px;
}

.available-check-in-box-container {
  min-height: 300px;
  max-height: 400px;
  overflow-y: auto;
}

.available-check-in-box {
  width: 500px;
  background: #fbfbfc;
  border-radius: 5px;
  border: 1px solid #d8d6de;
  padding: 16px;
  margin: 8px 0px;

  &:hover {
    cursor: pointer;
    background: #f7f6fe;
    border: 1px solid #7367f0;
  }
}

.active-card {
  background: #f7f6fe;
  border: 1px solid #7367f0;
}

.organization-name-container {
  max-width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-sub-max-width {
  max-width: 420px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @supports (-webkit-line-clamp: 2) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.check-in-width {
  width: 285px;
}
</style>
